.internal-comment {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
